module.exports = __webpack_public_path__ + "static/img/graphic-element-01.a9eb879.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/LimitedTimeOfferAd/graphic-element-01.png
// module id = vmEY
// module chunks = 1